import app from './app';
import user from './user';
import games from './games';
import modals from './modals';
import modals_action from './modals_action';
import modals_info from './modals_info';
import vip from './vip';
import vip20 from './vip20';
import wallet from './wallet';
import wheel from './wheel';
import invite from './invite';
import freecash from './freecash';
import tournaments from './tournaments';
import tasks from './tasks';
import lootbox from './lootbox';
import notifications from './notifications';
import popups from './popups';
import lucky_wheel from './lucky_wheel';
import modules from './modules';

export default {
    app,
    user,
    games,
    modals,
    modals_action,
    modals_info,
    vip,
    vip20,
    wallet,
    wheel,
    invite,
    freecash,
    tournaments,
    tasks,
    lootbox,
    notifications,
    popups,

    lucky_wheel,
    modules
}